export default "__VITE_ASSET__CdDeLgTC__"